import PropTypes from "prop-types";
import React from "react";
import { formatPackageMoney, packageStatusLabel } from "./packageBalanceContract";

const balanceMoney = (balance, field) => formatPackageMoney({ amountMinor: balance[field], currency: balance.currency });

const PackageBalanceCard = ({ packageBalance, onViewUsage }) => (
  <article className="text-decoration-none event-box-pink mb-3" data-id={packageBalance.id || packageBalance.packageInstanceId || undefined}>
    <h6 className="mb-1 color-wine fw-semibold d-flex justify-content-between align-items-start">
      {packageBalance.name}
      <span className="active">{packageStatusLabel(packageBalance.status)}</span>
    </h6>
    {packageBalance.packageInstanceId != null && <div className="small text-muted mb-2">Purchase #{packageBalance.packageInstanceId}</div>}
    {packageBalance.purchasedAt && <div className="small color-default mb-2">Purchased: {packageBalance.purchasedAt}</div>}
    <div className="row"><span className="col-6">Purchase amount</span><span className="col-6 text-end">{formatPackageMoney(packageBalance.purchaseAmount)}</span></div>
    <div className="row"><span className="col-6">Original credit</span><span className="col-6 text-end">{balanceMoney(packageBalance.balance, "originalMinor")}</span></div>
    <div className="row"><span className="col-6">Used credit</span><span className="col-6 text-end">{balanceMoney(packageBalance.balance, "netUsedMinor")}</span></div>
    <div className="row fw-semibold"><span className="col-6">Remaining credit</span><span className="col-6 text-end">{balanceMoney(packageBalance.balance, "remainingMinor")}</span></div>
    <div className="small text-muted mt-2">
      {packageBalance.expiry.status === "not_configured" ? "No expiry configured" : packageBalance.expiry.expiresAt ? `Expires ${packageBalance.expiry.expiresAt}` : "Expiry unavailable"}
    </div>
    {packageBalance.services.length > 0 && (
      <div className="mt-3" aria-label="Included services">
        <h6 className="mb-2 fw-semibold">Included services</h6>
        {packageBalance.services.map((service) => (
          <div className="d-flex justify-content-between small" key={service.id}>
            <span>{service.name}</span>
            <span className={service.used ? "color-wine fw-semibold" : "text-muted"}>
              {service.used ? "Credit used" : "Credit available"}
              {service.includedQuantity ? ` · ${service.includedQuantity} included` : ""}
            </span>
          </div>
        ))}
        <div className="small text-muted mt-1">
          {`Credit used against ${packageBalance.services.filter((service) => service.used).length} of ${packageBalance.services.length} included services.`}
        </div>
        {packageBalance.services.some((service) => service.snapshotQuality !== "snapshot") && (
          <div className="small text-muted mt-1">Legacy package names reflect the available historical catalog data.</div>
        )}
      </div>
    )}
    {packageBalance.products.length > 0 && (
      <div className="mt-3" aria-label="Included products">
        <h6 className="mb-2 fw-semibold">Included products</h6>
        {packageBalance.products.map((product) => (
          <div className="border-top py-2 small" key={product.entitlementId}>
            <div>
              <span>{product.name}</span>
              <span className="text-muted float-end">Product status: {packageStatusLabel(product.status)}</span>
              <div className="text-muted">
                {`${product.originalQuantity} original · ${product.usedQuantity} used · ${product.remainingQuantity} remaining`}
              </div>
            </div>
          </div>
        ))}
        {packageBalance.products.some((product) => product.snapshotQuality !== "snapshot") && (
          <div className="small text-muted">Legacy product names reflect the available historical catalog data.</div>
        )}
      </div>
    )}
    {packageBalance.attributionAvailable ? (
      <button type="button" className="btn btn-outline btn-sm mt-3" aria-label={`View credit usage for ${packageBalance.name}`} onClick={() => onViewUsage(packageBalance)}>
        View credit usage
      </button>
    ) : (
      <div className="small text-muted mt-3">Exact usage history is unavailable for this legacy package.</div>
    )}
  </article>
);

PackageBalanceCard.propTypes = {
  packageBalance: PropTypes.object,
  onViewUsage: PropTypes.func,
};

export default PackageBalanceCard;
